import * as React from "react";

import classnames from "classnames";

const FontAwesome = require("react-fontawesome");
const styles = require("./batchControlsStyles.module.scss");

/*
  This component contains the UI for a "Select All" checkbox and a <Select>
    for showing options for moving items to a new state
  This is a "dumb" display component that just triggers click handlers passed in as props

  The PARENT should track which items are batch selected, contain API logic, and pass it all down as props/callbacks
*/

interface Props {
  buttonLabel?: string;
  options?: string[][];

  className?: string;
  selectedItems: any[];

  // Controls styling (false by default)
  enabled?: boolean;

  // Function called on the dataset when a user clicks a selection:
  onSelectionFunction: Function;
}

const BatchControls: React.FC<Props> = ({
  buttonLabel,
  options,
  onSelectionFunction,
  selectedItems,
  enabled,
}: Props) => {
  return (
    <div className={classnames(styles.container, enabled && styles.containerEnabled)}>
      <div className={styles.button}>{buttonLabel}</div>

      {/* Button Icon & Modal */}
      <div className={styles.icon}>
        <FontAwesome name="caret-down" onClick={() => {}} />

        <ul className={styles.modal}>
          {options.map(([value, label]) => {
            return (
              <li
                key={value}
                onClick={() => {
                  onSelectionFunction(selectedItems, value);
                }}
              >
                {label}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default BatchControls;
